import React, { FC, ReactNode } from 'react';
import { Container } from '@material-ui/core';

interface LayoutProps {
  children: NonNullable<ReactNode>;
}

export const Layout: FC<LayoutProps> = ({ children }) => (
  <Container maxWidth="lg">{children}</Container>
);
